export default __webpack_public_path__ + "media/images/landing-3-550x420-27215c0431106467d24efce99f7a9f49.jpg";